// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"8493063a","721":"4319cac0","780":"f6dfce9f"}[chunkId] + ".chunk.js";
};